export const PREMIUM_SOURCE_BADGE_LABEL_MESSAGE = {
    id: '01812bc419',
    defaultMessage: 'Premium Source',
    description: 'Tooltip title for a source badge indicating the source is premium',
};
export const PREMIUM_SOURCE_BADGE_SUBTITLE_MESSAGE = {
    id: 'f7fff83465',
    defaultMessage: 'Licensed content included with your Perplexity subscription.',
    description: 'Tooltip subtitle explaining what a premium source is',
};
export const PREMIUM_SOURCE_BADGE_SHORT_LABEL_MESSAGE = {
    id: '6ee577df2c',
    defaultMessage: 'Premium',
    description: 'Short label in the expanded premium source badge pill',
};
//# sourceMappingURL=PremiumSourceBadgeMessages.js.map